import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class Social extends Component {

  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/screenshots/lrg/apricot-food-fruit-7961.jpg"
          heading="The Social Cuisiner"
          content={[
            <>
              <p>
                This is a simple fictional social network project that focuses
                on the love of food and recipe sharing. This was originally put
                together a couple of years ago. And has recently undergone a
                major redesign. Some of the featured details of this project
                are:
              </p>

              <ul className="features">
                <li>Built with HTML, CSS, JavaScript, PHP, and MYSQL</li>
                <li>User authorization system, using PHP, and JavaScript</li>
                <li>
                  User profiles where users can keep track of their posts,
                  friend's posts
                </li>
                <li>
                  Real-time Ajax search, as well as real-time likes, and
                  comments{" "}
                </li>
                <li>
                  CRUD capabilities, including the ability to edit/delete posts,
                  and comments{" "}
                </li>
              </ul>
            </>,
          ]}
          website="http://www.mlmontheweb.com/projects/social/index.php"
          github="https://github.com/Jimmyelvis/socialcuisineer"
          techs={[
            <>
              <li>PHP</li>
              <li>JavaScript</li>
              <li>MySQL</li>
              <li>Ajax</li>
              <li>CSS Grid</li>
              <li>Flex-box</li>
              <li>Cropper.Js</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 3/15/2022"
                  desc={[
                    <>
                      <p>
                        A minor update which includes the ability to edit posts, and 
                        comments.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/RNhMxGFMGd4",
                      screenshot: "assets/img/screenshots/lrg/comments.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/JBlxgrIy6BI",
                      screenshot: "assets/img/screenshots/lrg/edit post.jpg",
                    },
                  ]}
                  gallery="3/15/2022"
                />

                <Updates
                  heading="UPDATE 8/24/2021"
                  desc={[
                    <>
                      <p>
                        This project has since undergone a major overhaul as far
                        as design and functionality goes. The previous design
                        used Bootstrap for the css, however that has now been
                        taken out in favor of using a combination of Css Grid,
                        and Flex-box.
                      </p>

                      <p>
                        Additionally certain functions such as liking a post, or
                        commenting on a post run smoother because both are done
                        asynchronously using Axios, for ajax calls, where as
                        before a page refresh was required.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=4JWkbYk9vjM",
                      screenshot: "assets/img/screenshots/lrg/login.jfif",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=h0-hCsC1KN4",
                      screenshot:
                        "assets/img/screenshots/lrg/8c39b8f4-f63b-4a9b-9174-42dacb9389ec.jfif",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/84d1bbbe-a3f1-4339-bbcb-afe1100c9be8.jfif",
                      screenshot:
                        "assets/img/screenshots/lrg/84d1bbbe-a3f1-4339-bbcb-afe1100c9be8.jfif",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/129b8873-fc3c-48d5-847d-8238466f030e.jfif",
                      screenshot:
                        "assets/img/screenshots/lrg/129b8873-fc3c-48d5-847d-8238466f030e.jfif",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=fD5-88NFrU0",
                      screenshot:
                        "assets/img/screenshots/lrg/e84b5928-10e7-4fbc-95c3-b00563726408.jfif",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=XPs1Ho1ufBo",
                      screenshot: "assets/img/screenshots/lrg/postdetail.jfif",
                    },
                    {
                      video: "yes",
                      fullimage: "https://www.youtube.com/watch?v=P_efWEtMXnE",
                      screenshot:
                        "assets/img/screenshots/lrg/c6724142-1f59-4ba8-9587-2d7c812081ec.jfif",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/a99f7f44-4aa1-4b6d-b782-c3c85c29696f.jfif",
                      screenshot:
                        "assets/img/screenshots/lrg/a99f7f44-4aa1-4b6d-b782-c3c85c29696f.jfif",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/05a8c0b9-da13-4080-9c5a-f0f631a887c1.jfif",
                      screenshot:
                        "assets/img/screenshots/lrg/05a8c0b9-da13-4080-9c5a-f0f631a887c1.jfif",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/0be5b2f4-be0c-418d-a540-711f85f24ea4.jfif",
                      screenshot:
                        "assets/img/screenshots/lrg/0be5b2f4-be0c-418d-a540-711f85f24ea4.jfif",
                    },
                  ]}
                  gallery="8/24/2021"
                />
              </div>
            </>,
          ]}
          images={[
            <>
              <Imagerow images="assets/img/screenshots/lrg/login.png" />
              <Imagerow images="assets/img/screenshots/lrg/cuisiener_index.png" />
              <Imagerow images="assets/img/screenshots/lrg/friends.png" />
              <Imagerow images="assets/img/screenshots/lrg/rtytry.png" />
              <Imagerow images="assets/img/screenshots/lrg/cuisiener_dylancougar.png" />
            </>,
          ]}
          style={{
            backgroundColor: "rgb(18 43 111)",
            opacity: "0.6",
          }}
        />
      </React.Fragment>
    );
  }
}

export default Social
